import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "src/components/layout"
import SEO from "src/components/seo"
import Img from "gatsby-image"


class IndexPost extends React.Component {

  render() {

    const { data } = this.props;
    //console.log(data);
    console.log(`ALL DATA:`, data)

    return (
      <React.Fragment>
          <div className="recentYouTubeVideos">
          {data.data.ChoflyEliteAgeOfEmpiresYouTubeVideos ?
            <>
            <h2>My Recent <b>Age of Empires</b> Videos</h2>
            <div className="videos-wrap">
              {data.data.ChoflyEliteAgeOfEmpiresYouTubeVideos.edges.map(items => (
                <iframe key={items} src={`https://www.youtube-nocookie.com/embed/${items.node.videoId}`} title={items.node.title} alt={items.node.title} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              ))}
            </div>
            <a className="btn btnGreen moveUp" href="https://www.youtube.com/channel/UCVTaqy6DH6B0TQpwapqBXfg" rel="noopener noreferrer">View More</a>
            </>
          :
            <div className="hidden"></div>
          }
          {data.data.OfficialAgeOfEmpiresYouTubeVideos ?
            <>
            <h2>Recent Offical <b>Age of Empires</b> Videos</h2>
            <div className="videos-wrap">
              {data.data.OfficialAgeOfEmpiresYouTubeVideos.edges.map(items => (
                <iframe key={items} src={`https://www.youtube-nocookie.com/embed/${items.node.videoId}`} title={items.node.title} alt={items.node.title} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              ))}
            </div>
            <a className="btn btnGreen moveUp" href="https://www.youtube.com/channel/UCidjrp1fZd8TehYD2eYYPvg" rel="noopener noreferrer">View More</a>
            </>
          :
            <div className="hidden"></div>
          }
        </div>
      </React.Fragment>
    );
  }
}

const IndexPage = data => (

  <Layout>
    <SEO
    title="Chofly Elite"
    ogTitle="Chofly Elite - Age of Empires"
    ogURL="https://choflyelite-legacy.netlify.com"
    ogDescription="Chofly Elite - Age of Empires | Gaming Content Producer | Currently focussed on RAID Shadow Legends | Plarium Moderator | Twitch Streamer | YouTube Content Creator | Chofly Elite Community Discord"
    ogImage={data.data.home.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${data.data.home.featured_image[0].id}.${data.data.home.featured_image[0].extension}` : ""}
    ogImageSecure={data.data.home.featured_image ? `${'https://api.flotiq.com'}/image/0x0/${data.data.home.featured_image[0].id}.${data.data.home.featured_image[0].extension}` : ""}
    keywords={['Chofly Elite', 'ChoseN', 'Raid', 'Raid Shadow Legends', 'Twitch Streamer', 'YouTuber', 'Content Creator', 'YouTube Content Creator', 'Plarium Moderator',]}
    />
    <div className="container">
      <div className="container-content-wrap">
        <br />
        <div className="text-center"><h1 className="with-underline">Age of Empires</h1></div>
        <div className="category-page-wrap newWorld">
          <section>
            <h2><a href="https://www.ageofempires.com/" target="_blank" rel="noopener noreferrer" alt="Cick to view Age of Empires's Offical Website in new tab" title="Cick to view Age of Empires's Offical Website in new tab">Offical Website</a> | <a href="https://forums.ageofempires.com/" target="_blank" rel="noopener noreferrer" alt="Cick to view Age of Empires's Offical Forum in new tab" title="Cick to view Age of Empires's Offical Website in new tab">Offical Forum</a></h2>

{/*             <h3 className="with-underline">Guides & Resources</h3>
            <p className="guides-list">
                <div>
                  <a href="https://www.newWorld101.com/" target="_blank" rel="noopener noreferrer" alt="Community Wiki" title="Community Wiki">NewWorld 101</a>
                </div>
                <div>
                  <a href="https://newWorldofcreation.wiki/" target="_blank" rel="noopener noreferrer" alt="Community Wiki" title="Community Wiki">Community Wiki</a>
                </div>
                <div>
                  <a href="https://verracaravan.com/" target="_blank" rel="noopener noreferrer" alt="Verra Caravan - Your Age of Empires Resource" title="Verra Caravan - Your Age of Empires Resource">Verra Caravan - Your Age of Empires Resource</a>
                </div>
                <div>
                  <a href="https://www.hellhades.com/introduction-to-the-4-nodes-in-newWorld-of-creation/" target="_blank" rel="noopener noreferrer" alt="HellHades: Introduction to the 4 Nodes in Age of Empires" title="HellHades: Introduction to the 4 Nodes in Age of Empires">HellHades: Introduction to the 4 Nodes in Age of Empires</a>
                </div>
                <div>
                  <a href="https://www.mmorpg.com/newWorld-of-creation/articles" target="_blank" rel="noopener noreferrer" alt="MMORPG Articles" title="MMORPG Articles">MMORPG Articles</a>
                </div>
            </p> */}
          </section>
          <br />
          <IndexPost data={data} />
{/*          <h2>Lorem ipsum dolor</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis. Mi eget mauris pharetra et ultrices neque. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis. Mi eget mauris pharetra et ultrices neque.</p>*/}
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage



export const query = graphql`
  query NewWorldPageQuery {


      home {
        heading
        content
        featured_image {
          id
          fileName
          extension
        }
        game_logos {
          extension
          fileName
          url
          size
          id
          height
          width
          type
        }
        game_logo_width
        game_logo_margin
      }


      OfficialAgeOfEmpiresYouTubeVideos: allYoutubeVideo (
        sort: {order: DESC, fields: publishedAt},
        filter: {
          channelId: {eq: "UCidjrp1fZd8TehYD2eYYPvg"},
        }
      ) {
        edges {
          node {
            id
            title
            videoId
            description
            thumbnail {
              url
              height
              width
            }
            channelId
            channelTitle
            publishedAt
            privacyStatus
          }
        }
      }


      ChoflyEliteAgeOfEmpiresYouTubeVideos: allYoutubeVideo (
        sort: {order: DESC, fields: publishedAt},
        filter: {
          channelId: {eq: "UCVTaqy6DH6B0TQpwapqBXfg"},
        }
      ) {
        edges {
          node {
            id
            title
            videoId
            description
            thumbnail {
              url
              height
              width
            }
            channelId
            channelTitle
            publishedAt
            privacyStatus
          }
        }
      }


  }
`





